<main>
	<div class="container" *ngIf="docs"	style="padding-bottom: 100px;">
		<section class="steps">
			<h1>{{'TITLE' | translate | capitalizeFirst}}</h1>
		</section>
		<div class="cnt-upload-doc">
			<div [innerHTML]="'UPLOAD_TEXT' | translate:{size:fileService.returnFileSize(maxSize),maxFiles:maxFiles}"></div>
			<div class="cnt-table-doc" *ngIf="isAnyConfirmedDoc()" style="margin-bottom: 20px;">
				<h3>{{'CONFIRMED_DOCS' | translate | capitalizeFirst}}</h3>
				<section class="table">
					<div class="body-table">
						<ul class="row-table" *ngFor="let docGroup of getConfirmedDocs()">
							<li class="doc-descript">
								<dl>
									<dd>
										{{docGroup[0].descrizioneTipoDocumento}}
									</dd>
									<dt style="padding-left: 50px;">
										<div *ngFor="let doc of docGroup">
											{{'PAGE' | translate | capitalizeFirst}} {{doc.numeroPagina}} - {{'CONFIRMED_ON' | translate | capitalizeFirst}} {{doc.dataConferma |date:'dd/MM/yyyy'}}
										</div>
									</dt>
								</dl>
							</li>
						</ul>
					</div>
				</section>
			</div>
			<div class="cnt-table-doc">
				<h3>{{'REQUESTED_DOCS' | translate | capitalizeFirst}}</h3>
				<section class="table">
					<div class="header-table">
						<ul>
							<li class="doc-descript">{{'DOC_DESCRIPTION' | translate | capitalizeFirst}}</li>
							<li class="doc-buttons">{{'SELECT_DOCS' | translate | capitalizeFirst}}</li>
						</ul>
					</div>
					<div class="body-table">
						<div class="row-table" *ngFor="let doc of docs.documentiRichiesti; index as i">
							<ul>
								<li class="doc-descript">
									{{doc.descrizioneTipoDocumento}}
									<ng-container *ngIf="!moreDocsOfTypeAllowed(doc.codiceTipoDocumento)">
										<span style="color:darkred;"><br>{{'UPLOAD_MAX_WARNING'|translate:{maxFiles:maxFiles} }}</span>
									</ng-container>
								</li>
								<li class="doc-buttons">
									<!--<button type="button" class="js-toggle c-badge-button" data-message-count="2"></button>-->
									<ng-container *ngIf="moreDocsOfTypeAllowed(doc.codiceTipoDocumento)">
										<input
											type="file"
											#upload
											(change)="onFileChange($event, doc)"
											accept="image/jpeg, image/tiff, image/x-tiff, .tif, .tiff, application/pdf">
											<!-- accept="image/png, image/jpeg, image/tiff, image/x-tiff, .tif, .tiff, application/pdf"> -->
										<input
											type="button"
											class="upload"
											(click)="upload.click()"
										>
									</ng-container>
									<!--<input type="button" class="zoom">-->
									<div
										class="container__badge"
										[style.visibility]="doc.nDocumentiCaricati > 0 ? null : 'hidden'"
									>
										<input
											type="button"
											class="delete"
											(click)="onZoom(doc.codiceTipoDocumento)"
										>
										<span class="badge">{{doc.nDocumentiCaricati}}</span>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</section>
			</div>
      <div class="row-buttons"
           *ngIf="isAnyNotConfirmedDoc()">
        <!-- *ngIf="areAllDocsLoaded()"> -->
        <button type="button" (click)="confirm()">{{'CONFIRM' | translate | capitalizeFirst}}</button>
      </div>
      <ul class="legenda">
				<li>{{'LEGEND_1' | translate | capitalizeFirst}}</li>
				<li>{{'LEGEND_2' | translate | capitalizeFirst}}</li>
				<li>{{'LEGEND_3' | translate | capitalizeFirst}}</li>
			</ul>
		</div>

	</div>
</main>
<app-popup (clickDoc)="clickDoc($event)" (deleteDoc)="deleteDoc($event)"></app-popup>
